import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';

export const DemoLayout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 7000);

    return () => {
      clearTimeout(timer);
    };
  });

  const demoLink = localStorage.getItem('demoLink');

  return (
    <Box
      sx={{
        width: '1680',
        height: '100%',
        bgcolor: '#FAFAFA',
      }}
    >
      {loading && <CircularProgressCentered />}
      {demoLink && (
        <iframe
          title="demo"
          style={{ border: 'none', visibility: loading ? 'hidden' : 'visible' }}
          width="1680"
          height="100%"
          src={`${demoLink}&hide-ui=1`}
          allowFullScreen
        ></iframe>
      )}
    </Box>
  );
};
